import { Product } from 'app/shared/model/ProductBase';
import React from "react";
import { Row, Col, Pagination, Select } from 'antd';

interface TablePaginationProps {
    itemsPerPageOptions?: number[],
    onItemsPerPageChange: (value: number, currentPage: number) => void,
    onPageChange: (value: number) => void,
    noOfItems: number,
    itemsPerPage: number,
    currentPage: number,
    showItemsPerPage: boolean
}

const Paging = (props: TablePaginationProps) => {

    const defaultItemsPerPageOptions:number[] = [10, 20, 50, 100, 250];

    const pageOptions = props.itemsPerPageOptions ? props.itemsPerPageOptions : defaultItemsPerPageOptions;

    const totalPages = Math.ceil(props.noOfItems / props.itemsPerPage);

    return (
        <Row align="middle" style={{ marginTop: 12, marginBottom: 12 }}>
            <Col flex="auto" style={{ textAlign: "right" }}>
                <Pagination
                    current={props.currentPage}
                    total={props.noOfItems}
                    pageSize={props.itemsPerPage}
                    onChange={(page) => props.onPageChange(page)}
                    showSizeChanger={false}
                    showQuickJumper={totalPages > 10}
                    hideOnSinglePage={totalPages <= 1}
                />
            </Col>
            {props.showItemsPerPage &&
                <Col style={{ minWidth: 160, textAlign: "right", marginLeft: 10 }}>
                    <Select
                        style={{ width: 120 }}
                        value={props.itemsPerPage}
                        onChange={val => props.onItemsPerPageChange(Number(val), 1)}
                        options={pageOptions.map(p => ({
                            label: `${p} / Page`,
                            value: p,
                        }))}
                    />
                </Col>
            }
        </Row>
    );
};

const dataPaging = <T extends Product | Date>(dataList: T[], currentPage: number, itemsPerPage: number): T[] => {
    let batchStart: number = (currentPage === 1) ? 0 : (currentPage - 1) * itemsPerPage;
    let batchCount: number = currentPage * itemsPerPage;

    return dataList.slice(batchStart, batchCount);
};

const TablePagination = {dataPaging, Paging};

export default TablePagination;